module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table"
  }, [(_vm.view_mode.filters) ? _c('div', {
    staticClass: "table-actions"
  }, [_c('filters', {
    attrs: {
      "filters": _vm.filters
    },
    on: {
      "filter": _vm.filter
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "table-header table-row"
  }, [_c('div', {
    staticClass: "table-col contact-list-item-select table-col-collapsed"
  }, [_c('div', {
    staticClass: "checkbox-inline contact-list-item-checkbox-item",
    attrs: {
      "id": "contact-select-all-checkbox"
    },
    on: {
      "click": function($event) {
        return _vm.toggleSelectAll()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.selected_all
    }
  }), _c('label', [_vm._v(" ")])])]), _c('div', {
    staticClass: "table-col table-col-empashis contact-list-item-name table-col-120"
  }, [_vm._v(_vm._s(_vm.$t('groups.attributes.Name')))]), (_vm.view_mode.statistics) ? _c('div', {
    staticClass: "table-col"
  }) : _vm._e(), _c('div', {
    staticClass: "table-col"
  }), (_vm.view_mode.user) ? _c('div', {
    staticClass: "table-col contact-list-item-user"
  }, [_vm._v(_vm._s(_vm.$t('groups.attributes.Responsible')))]) : _vm._e(), (_vm.view_mode.actions_dropdown) ? _c('div', {
    staticClass: "table-col contact-list-item-actions table-col-collapsed"
  }) : _vm._e()]), _c('div', {
    staticClass: "table-body"
  }, _vm._l((_vm.contact_groups), function(contact_group, contact_group_id) {
    return _c('contact-group-list-item', {
      attrs: {
        "contact_group": contact_group,
        "view_mode": _vm.view_mode,
        "initially_selected": _vm.selected_all,
        "selected_contact_ids": _vm.selected_contact_ids
      },
      on: {
        "group-destroy": _vm.bubbleUp,
        "group-selected": _vm.bubbleUp
      }
    })
  }), 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4ab01e7e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/contact_groups/list.vue
// module id = 1099
// module chunks = 1